/**
 * Abstract Base Renderer Class
 */

import type { Block } from "../types";

export abstract class BlockRenderer {
  protected blocks: Block[];
  protected modelScale: number;

  constructor(blocks: Block[], modelScale: number) {
    this.blocks = blocks;
    this.modelScale = modelScale;
  }

  /**
   * Render the blocks with the given dimensions and rotation
   */
  abstract render(
    width: number,
    height: number,
    rotX: number,
    rotY: number,
    zoom?: number
  ): void;

  /**
   * Clean up renderer resources
   */
  abstract dispose(): void;
}
